export default __webpack_public_path__ + "static/media/broker-icon.5312df1c.svg";